import styled from "@emotion/styled";
import { ChevronDown as ChevronBottomIcon } from "src/icons/ChevronDown";

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
`;

const ChevronBottom = styled(ChevronBottomIcon)`
  margin-left: ${({ theme }) => theme.space[1]}px;
  margin-top: 2px;
`;

const Select = styled.select`
  z-index: 1;
  position: absolute;
  top: 0;
  opacity: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export { Wrapper, ChevronBottom, Select };
